<div class="my-4">
  <div class="mb-4 text-center font-semibold">{{ title }}</div>
  <cipx-file-upload
    (fileUploadChanged)="onFileUploadChanged($event)"
    [currentConfig]="uploadConfig"
    [isUploading]="isUploading"
    [multiple]="true"
    class="w-full"></cipx-file-upload>
</div>
